<svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.692383" width="60" height="60" rx="16" fill="#F3F3F3"/>
<path d="M37.8428 18.9736H41.7584L33.2039 28.7509L43.2676 42.0556H35.3878L29.2161 33.9864L22.1542 42.0556H18.2362L27.3861 31.5977L17.7319 18.9736H25.8118L31.3905 26.3492L37.8428 18.9736ZM36.4685 39.7119H38.6382L24.6328 21.1942H22.3045L36.4685 39.7119Z" fill="black"/>
</svg>
